import { useEffect, useState } from 'react'
import './myCss.css';
import './dsCSS.css'
import axios from 'axios'
import DeveloperComponent from './DeveloperComponent'
import me from './images/me.jpg'
import Projects from './Projects'
import js from './images/JavaScript-logo.jpg'
import python from './images/python-logo.jpg'
import ts from './images/TS.jpeg'
import psql from './images/psql.jpg'
import react from './images/react.jpg'
import html from './images/html.jpg'
import css from './images/css.jpg'
import tailwind from './images/tailwind.jpg'
import Social from './Social'
import Gallery from './Gallery'
import leetcode from './images/leetcode1.jpg'
import { Link } from 'react-router-dom'



function Welcome() {
    var visitor 
    const [origLoad, setOrigLoad] = useState(true)
    const [bottomLoad, setBottomLoad] = useState(false)
    const [visitorCount, setVisitorCount] = useState("");

    async function getVisitorCount() {
        if (origLoad)
        try {
            let result = await axios.get('https://jn-dev-backend.onrender.com')
            setBottomLoad(true)
            let visitor = result.data.ans.total-2
            setVisitorCount(visitor -=2)
            postVisitorCount()  
        } catch (err) {
            console.error(err)
        }
    }

    async function postVisitorCount() {
        if (origLoad) {
        try {
            let result = await axios.post('https://jn-dev-backend.onrender.com')
            console.log(result)
            setOrigLoad(false)
            setBottomLoad(true)
            getVisitorCount()
        }
        catch (error) { console.error('Error incrementing visit:', error) };
        } 
        
    }

    useEffect(() => {
        // postVisitorCount();
        getVisitorCount();
    }, []); 

    
    return (
        <>
        <div id='body-frontpage'>

            <div className='image'>
                <img src={me} className="me" alt="avatar"></img>

                <div className='bio'>
                    <h1 className='intro intro-headline'>
                        <span className='intro-line intro-line-greeting'>
                            Hi, my name is Jeffrey Ng.
                        </span>
                        <span className='intro-line-row'>
                            <span className='intro-line'>I am a</span>
                            <span className='intro-line-role'>
                                <DeveloperComponent />
                            </span>
                        </span>
                    </h1>
                </div>

            </div>


            <div className='technology-links'>

                <span className='description-link'>
                    <h5 id='separate'><Link to='/'>Home</Link></h5>
                    <h5 id='separate'><a href='https://jeffreyng512137e14.myportfolio.com/' target="_blank" rel='noreferrer'>Data Science</a></h5>
                    {/* <h5 id='separate-1'><a href='#gallery'>Gallery</a></h5> */}
                    {/* <h5 id='separate'><a href='https://jeffreyng512137e14.myportfolio.com/' target='_blank' rel='noreferrer'>DS</a></h5> */}
                    <h5 id='separate' className='projects-dropdown'>
                        <button className='projects-dropdown-trigger' type='button'>Additional Projects</button>
                        <span className='projects-dropdown-menu'>
                            <a href='https://study-buddy-1-0.io' target="_blank" rel='noreferrer'>Study Buddy 1.0</a>
                            <a href='https://nature-venomous-retired.ngrok-free.dev/' target="_blank" rel='noreferrer'>Scrabble</a>
                        </span>
                    </h5>
                    <h5 id='separate'><Link to='/timeline'>Timeline</Link></h5>
                    {/* <h5 id='separate'><a href='https://drive.google.com/file/d/1jJGfSGqHdkAxGPh7G1xQ79K0GNpyhXEo/view?usp=sharing' target="_blank" rel='noreferrer'>Paper</a></h5> */}
                </span>
            </div>

            <h1 className='description-4'>In 2023, I wanted to expand my skillset into web development and started studying languages and tools such as <span>React, React Native, JavaScript/TypeScript, Python, Tailwind CSS.</span> I have a knack for producing practical software and at the moment, I am developing a <span>Scrabble Game and beta version of News Aggregator</span></h1>
            <Projects />

            <div className='ltc'>
                <h1 className='description-3'>Leetcode Practice Problems</h1>
                <img className= 'leetcode-pic' src={leetcode} alt='leetcode' />
            </div>

   
            
            <div className='display'>
                <h1 id='display'>Currently, I am taking Computer Science classes at <span id='college'>Southern New Hampshire University. </span>Relevant coursework include: <span>Statistics, Scripting, Discrete Math, Bayes Theorem, Linear Algebra, Calculus I, II, and SDLC.</span></h1>
            </div>

            <div className='technology'>
                <img src={js} className="techstack" alt="avatar"></img>
                <img src={ts} className='techstack-ts' alt='avatar'></img>
                <img src={python} className="techstack-1" alt="avatar"></img>
                <img src={psql} className="techstack-psql" alt="avatar"></img>
                <img src={react} className="techstack-react" alt="avatar"></img>
                <img src={tailwind} className="techstack-tailwind" alt='avatar'></img>
                <img src={html} className="techstack-html" alt="avatar"></img>
                <img src={css} className="techstack-css" alt="avatar"></img>
            </div>

            <h1 className='description'>
                I spent Jan 2022 - Nov 2023 at <span className='company'>Publicis Collective</span> engineering Python scripts to process company data into reports for other departments, cleaning advertising data with Excel, and built soft skills for <span>effective team communications, following up effectively, and meeting deadlines.</span>
            </h1>

            <h1 className='description'>
                In Dec 2023 - Apr 2024, I self-studied more Python and added Javascript and its libraries into my techstack. I <span>started an LLC to freelance</span> and help build an Airbnb property management system (PMS) to hold reservations. Also a <span>co-founder of a startup</span> that dovetails into my previous News Aggregator project. 
            </h1>
 
            <h1 className='description'>
                <span>Study Buddy 1.0</span> - my latest project, is vibe-coded and is intended to be a business under JN Web Solutions LLC. Here, I used best design, UI judgement, a tech stack best designed to handle webpage demands, and trouble shooted <span>AWS deployment.</span> Its front end is on Cloudflare. It has a state of the art summarizing feature using <span>Claude Opus 4.6</span> which can output diagrams and charts based on your notes.   
            </h1>
            <div className='component-grouping'>
                <div className='gallery' id='gallery'>
                    <Gallery />
                </div>
           
                <Social />

                
                <div className='visitors'>
                    <div id='visitor-counter'>Visitors: {visitorCount}</div>
                    <h6 className='copyright'>
                        Jeffrey Ng - All Rights Reserved, 2025
                    </h6>
                </div>
           
            </div>
           
        </div>
</>

    )
}




export default Welcome
